import {
	Component, OnDestroy, OnInit, ViewChild, ChangeDetectorRef, ElementRef,
	Input, AfterViewInit, EventEmitter, Output
} from '@angular/core';
import { CustomerService } from '../../services/customer.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UntypedFormControl } from '@angular/forms';
import { GlobalSearchService } from '../../services/globalsearchservice.service';
import { PrintService } from '../../services/print.service';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Observable } from 'rxjs';

@Component({
	selector: 'app-customer-no-purchase',
	templateUrl: './customer-no-purchase.component.html',
	styleUrls: ['./customer-no-purchase.component.scss'],
})
export class CustomerNoPurchaseComponent implements OnInit, AfterViewInit, OnDestroy {
	@Input() flip = 'inactive';

	@Input() dummydata = false;
	@Output() viewData = new EventEmitter<any>();
	@ViewChild('monthDetails') monthDetailsRef: ElementRef;
	@ViewChild('print_table') printtable: ElementRef;
	@ViewChild(MatPaginator) paginator: MatPaginator;
	@ViewChild(MatSort) sort: MatSort;

	dataSource: MatTableDataSource<any>;
	dataObs: Observable<any>;

	items_per_page = [25, 50, 100, 500];
	pagesizedefaultNop = 50;

	viewing: any = false;
	hideshowunits = new UntypedFormControl(true);
	hideshowsales = new UntypedFormControl(true);
	hideshowcost = new UntypedFormControl(false);
	defaultlocation = new UntypedFormControl('');
	data: any = false;
	sending = false;
	// Re-engagement window lower bound. Shortened from 60 to 35 days (5 weeks) per
	// the Jul-2026 sales review (Al/AA): flag lost customers at the agreed 4–6 week
	// mark instead of 60 days. User-adjustable via the days filter input.
	days = 35;
	daysmax = 365;
	title = `No Purchases ${this.days}/${this.daysmax} Days`;
	total = 0;
	brand_details: any = false;
	datasub: any = false;
	pageindex = 0;
	exporting = false;

	user: any = false;
	ref_location: any = false;
	filename = this.title;
	showFirstLastButtons = true;
	showPageSizeOptions = true;
	hidePageSize = false;

	showFilters = false;
	avgDaysSince = 0;
	totalPriorSpend = 0;

	color = 'blue';

	private static readonly THEME_PALETTE: Record<string, { light: [number, number, number]; base: [number, number, number]; dark: [number, number, number] }> = {
		purple:  { light: [206, 147, 216], base: [156,  39, 176], dark: [ 74,  20, 140] },
		primary: { light: [206, 147, 216], base: [156,  39, 176], dark: [ 74,  20, 140] },
		blue:    { light: [144, 202, 249], base: [ 33, 150, 243], dark: [ 25, 118, 210] },
		info:    { light: [128, 222, 234], base: [  0, 188, 212], dark: [  0,  96, 100] },
		green:   { light: [165, 214, 167], base: [ 76, 175,  80], dark: [ 27,  94,  32] },
		success: { light: [165, 214, 167], base: [ 76, 175,  80], dark: [ 27,  94,  32] },
		orange:  { light: [255, 204, 128], base: [255, 152,   0], dark: [230,  81,   0] },
		warning: { light: [255, 224, 130], base: [255, 193,   7], dark: [255, 143,   0] },
		red:     { light: [239, 154, 154], base: [244,  67,  54], dark: [183,  28,  28] },
		danger:  { light: [239, 154, 154], base: [244,  67,  54], dark: [183,  28,  28] },
		rose:    { light: [244, 143, 177], base: [233,  30,  99], dark: [136,  14,  79] },
	};

	get palette() {
		return CustomerNoPurchaseComponent.THEME_PALETTE[this.color] || CustomerNoPurchaseComponent.THEME_PALETTE['blue'];
	}

	get themeVars(): { [key: string]: string } {
		const p = this.palette;
		const rgb  = (c: number[]) => `rgb(${c[0]},${c[1]},${c[2]})`;
		const rgba = (c: number[], a: number) => `rgba(${c[0]},${c[1]},${c[2]},${a})`;
		return {
			'--cnp-accent':        rgb(p.base),
			'--cnp-accent-dark':   rgb(p.dark),
			'--cnp-accent-light':  rgb(p.light),
			'--cnp-accent-tint':   rgba(p.base, 0.07),
			'--cnp-accent-tint-2': rgba(p.base, 0.14),
			'--cnp-accent-border': rgba(p.base, 0.20),
			'--cnp-accent-bg':     rgba(p.light, 0.16),
		};
	}

	constructor(
		private _changeDetectorRef: ChangeDetectorRef,
		private printService: PrintService,
		public globalSearchService: GlobalSearchService,
		private customerService: CustomerService,
		private modalService: NgbModal
	) {
		this.color = 'warning';
	}

	ngOnInit(): void {
		this.setPagination([]);
		this.loadData();

		this.globalSearchService.user.subscribe(results => {
			if (this.user) {
				if (results.user.defaultlocation.loccode !== this.ref_location) {
					this.defaultlocation.setValue(this.user.user.defaultlocation.loccode);
					this.ref_location = false;
				}
			}

			this.user = results;
			if (!this.ref_location) {
				this.ref_location = this.user.user.defaultlocation.loccode;
			}
		});
	}

	ngAfterViewInit(): void {
		if (this.dataSource) {
			this.dataSource.paginator = this.paginator;
			this.dataSource.sort = this.sort;
			this.dataObs = this.dataSource.connect();
		}
	}

	loadDataOnly(data) {
		this.customerService.getNoPurchaseCustomers(data).subscribe((results: any) => {
			this.sending = false;
			this.data = results;
			this.computeStats(results);
			this.setPagination(results);
		});
	}

	loadData() {
		const data = {
			numberofdays: this.days,
			daysmax: this.daysmax,
			pageindex: this.pageindex,
			pagesize: this.pagesizedefaultNop,
		};
		this.sending = true;
		this.datasub = this.customerService.getNoPurchaseCustomersCount(data).subscribe((r: any) => {
			if (r) {
				this.total = parseFloat(r.total); // always update total
			}

			this.loadDataOnly(data);
		});
	}

	computeStats(rows: any): void {
		this.avgDaysSince = 0;
		this.totalPriorSpend = 0;
		if (!rows || !rows.length) {
			return;
		}

		const now = Date.now();
		let dayssum = 0;
		let daycount = 0;
		let spend = 0;

		rows.forEach((row: any) => {
			spend += parseFloat(row.totalspend) || 0;
			const seen = row.lastseen ? new Date(row.lastseen).getTime() : NaN;
			if (!isNaN(seen)) {
				dayssum += Math.max(0, (now - seen) / 864e5);
				daycount++;
			}
		});

		this.avgDaysSince = daycount ? Math.round(dayssum / daycount) : 0;
		this.totalPriorSpend = spend;
	}

	getBrandSales(debtorno: any, brand: any) {
		const data = { debtorno, brands: [brand], from: 'all' };

		this.customerService.searchCustomerHistory(data).subscribe((results: any) => {
			this.sending = false;
			this.brand_details = results;
			this.modalService.open(this.monthDetailsRef, { ariaLabelledBy: 'modal-title', size: 'xl' });
		});
	}

	getCostTotalYear(year: any): number {
		return year.cost.reduce((acc: number, item: any) => acc + parseFloat(item.value), 0);
	}
	getSaleTotalYear(year: any): number {
		return year.sales.reduce((acc: number, item: any) => acc + parseFloat(item.value), 0);
	}
	getQtyTotalYear(year: any): number {
		return year.qty.reduce((acc: number, item: any) => acc + parseFloat(item.value), 0);
	}

	updateDays(event: any) {
		this.days = event.target.value;
	}
	updateDaysMax(event: any) {
		this.daysmax = event.target.value;
	}

	toggleFlip(data: any, title: string) {
		this.flip = data ? (this.flip === 'active' ? 'inactive' : 'active') : 'inactive';
		if (this.flip === 'active') {
			this.viewing = data;
			this.title = title;
			this.viewData.emit({ data, title: this.title , comp: 'nopurch' });
		} else {
			this.viewData.emit(false);
		}
	}

	exportPdf(html: string) {
		const encoded = this.globalSearchService.base64encode(html);
		const data = { content: encoded, filename: this.filename, landscape: true };
		this.printService.pdf(data).subscribe((result:any) => {
			this.globalSearchService.downloadPdf(result.content, data.filename);
		});
	}

	exportXls(html: string) {
		const encoded = this.globalSearchService.base64encode(html);
		const data = { content: encoded, filename: this.filename };
		this.printService.xls(data).subscribe((result:any) => {
			this.globalSearchService.downloadXls(result.content, data.filename);
		});
	}

	buildExportHtml(type: string) {
		if (!confirm('Warning: This report can take a long time to export.')) {return;}

		const data = {
			numberofdays: this.days,
			daysmax: this.daysmax,
			pageindex: 0,
			pagesize: this.total,
		};

		this.exporting = true;
		this.customerService.getNoPurchaseCustomers(data).subscribe((results: any) => {
			let html = `<table><thead><tr>
				<th style="text-align:left">Customer#</th>
				<th style="text-align:left">Name</th>
				<th style="text-align:left">Address1</th>
				<th style="text-align:left">City</th>
                                <th style="text-align:left">Region</th>
				<th style="text-align:left">Postal</th>
				<th style="text-align:left">SalesPerson</th>
				<th style="text-align:left">Last Seen</th>
				<th style="text-align:right">Total Spend</th>
				<th style="text-align:right">Avg Spend</th>
			</tr></thead><tbody>`;

			results.forEach(row => {
				html += `<tr>
					<td style="text-align:left">${row.debtorno}</td>
					<td style="text-align:left">${row.name}</td>
					<td style="text-align:left">${row.address1}</td>
					<td style="text-align:left">${row.address3}</td>
					<td style="text-align:left">${row.address4 || ''}</td>
					<td style="text-align:left">${row.address5}</td>
					<td style="text-align:left">${row.salesmanname?.name || ''}</td>
					<td style="text-align:left">${row.lastseen}</td>
					<td style="text-align:right">$${this.financial(+row.totalspend)}</td>
					<td style="text-align:right">$${this.financial(+row.avgspend)}</td>
				</tr>`;
			});

			html += '</tbody></table>';
			this.exporting = false;
			type === 'pdf' ? this.exportPdf(html) : this.exportXls(html);
		});
	}

	financial(num: number): number {
		return parseFloat((Math.round((num || 0) * 100) / 100).toFixed(2));
	}

	setPagination(tableData: any[]) {
		if (!this.dataSource) {
			this.dataSource = new MatTableDataSource<any>(tableData);
		} else {
			this.dataSource.data = tableData;
		}

		this._changeDetectorRef.detectChanges();

		if (this.paginator && this.sort) {
			this.dataSource.paginator = this.paginator;
			this.paginator.length = this.total;
			this.dataSource.sort = this.sort;
			this.dataObs = this.dataSource.connect();
		}
	}

	onPageChange(event: PageEvent) {
		this.pageindex = event.pageIndex;
		this.pagesizedefaultNop = event.pageSize;

		const data = {
			numberofdays: this.days,
			daysmax: this.daysmax,
			pageindex: this.pageindex,
			pagesize: this.pagesizedefaultNop,
		};

		this.loadDataOnly(data);
	}

	ngOnDestroy(): void {
		if (this.datasub) {
			this.datasub.unsubscribe();
		}
	}
}
